import { useContext } from 'react';
import { useNavigation } from '../../../utils/redirectUtils';
import { SourceContext } from '../../../utils/sourceContext';
import Header from '../../.shared/header/header';
import Footer from '../../.shared/footer/footer';
import PatientStories from '../../.shared/PatientStories/PatientStories';
import FAQ from '../../.shared/FAQ/FAQ';
import AsSeenOn from '../../.shared/AsSeenOn/AsSeenOn';
import HowItWorks from '../../.shared/HowItWorks/HowItWorks';
import WhatsIncluded from '../../.shared/WhatsIncluded/WhatsIncluded';
import PriceUpdateBanner from '../../Landing/PriceUpdateBanner/PriceUpdateBanner';
import Pricing from '../../../data/Pricing';
import { trackPostHogEvent } from '../../../utils/posthogUtils';
import { startInterview } from '../../../utils/interviewFlow';
import styles from './BaseLandingV3.module.css';
import heroPortrait from '../../../assets/hero-portrait-vial.webp';

export default function BaseLandingV3() {
    const { switchAndSave } = useContext(SourceContext);
    const navigate = useNavigation();

    const pricing = Pricing();
    const semaglutide = pricing.getPricingOptionsByProductName('semaglutide');
    const startingPrice = semaglutide?.injectable?.threeMonths?.monthly_amount?.split('.')[0] ?? null;

    const handleCta = (selected, path) => {
        // Only the funnel CTA enrolls; the other destinations are untouched.
        const flow = path === '/interview' ? startInterview() : null;

        trackPostHogEvent('landing_page_submitted', {
            selected,
            to_path: path,
            interview_flow: flow?.id
        });

        navigate(flow ? flow.entryPath : path);
    };

    return (
        <div className={styles.page}>
            {switchAndSave && <PriceUpdateBanner />}

            <Header hideNavigation />

            <section className={styles.heroA}>
                <div className={styles.heroAInner}>
                    <div className={styles.heroACopy}>
                        <div className={styles.heroAPill}>
                            <span className={styles.heroAPillDot} aria-hidden="true"></span>
                            Clinician-guided GLP-1 care
                        </div>
                        <h1 className={styles.heroATitle}>
                            Real people are losing <span className={styles.heroAGrad}>15–26%</span> of their body weight.
                        </h1>
                        <p className={styles.heroASub}>
                            Semaglutide and tirzepatide, prescribed and monitored by a licensed clinician.
                            One price for every dose — and no telehealth visit required for most prescriptions.
                        </p>
                        <div className={styles.heroAActions}>
                            <button type="button" className={styles.heroACta} onClick={() => handleCta('start_my_evaluation', '/interview')}>
                                Start My Evaluation
                            </button>
                            <button type="button" className={styles.heroACtaGhost} onClick={() => handleCta('see_pricing', '/programs')}>
                                See pricing
                            </button>
                        </div>
                        <p className={styles.heroAFinePrint}>
                            Takes about 2 minutes{startingPrice ? ` · Starting at $${startingPrice}/month` : ''} · Cancel anytime
                        </p>
                    </div>

                    <div className={styles.heroAMedia}>
                        <div className={styles.heroAFrame}>
                            <img src={heroPortrait} alt="TB2 patient holding a compounded GLP-1 vial" />
                        </div>
                        <div className={styles.heroAStat}>
                            <div className={styles.heroAStatNum}>−22%</div>
                            <div className={styles.heroAStatLabel}>
                                body weight in 9 months
                                <span className={styles.heroAStatWho}>Kayleigh · Ohio</span>
                            </div>
                        </div>
                        <div className={styles.heroANote}>
                            <div className={styles.heroANoteTitle}>One price, all doses</div>
                            <div className={styles.heroANoteBody}>Your dose goes up. Your bill doesn't.</div>
                        </div>
                    </div>
                </div>
            </section>

            <AsSeenOn />

            <HowItWorks />

            <WhatsIncluded />

            <PatientStories />

            <FAQ />

            <Footer />
        </div>
    );
}
